import { AnimatePresence } from 'motion/react';
import * as motion from 'motion/react-m';
import { memo } from 'react';
import { ImageComponent } from '@/components/Image';
import {
  type IResponsiveImageSrc,
  pickResponsiveSrc,
} from '@/modules/promotions/templates/HeadlinePromoTemplate/helpers';
import { useGetCommonStore } from '@/store';
import {
  DEVICE_ANIMATE_STILL,
  DEVICE_ANIMATE_VISIBLE,
  DEVICE_EXIT,
  DEVICE_INITIAL,
  DEVICE_LAYER_STYLE,
  DEVICE_STILL_TRANSITION,
  DEVICE_TRANSITION,
} from './motion';
import { ScCharacterImage } from './styled';

interface ICharacterImageProps {
  disableAnimation?: boolean;
  src: IResponsiveImageSrc;
}

export const CharacterImage = memo(
  ({ disableAnimation, src }: ICharacterImageProps) => {
    const useCommonStore = useGetCommonStore();
    const isMobileDevice = useCommonStore.use.isMobileDevice();
    const resolvedSrc = pickResponsiveSrc(src, isMobileDevice);

    const image = (
      <ScCharacterImage $disableAnimation={disableAnimation}>
        <ImageComponent
          alt="reward device"
          className="device"
          height={523}
          src={resolvedSrc}
          width={520}
        />
      </ScCharacterImage>
    );

    return (
      <AnimatePresence mode="popLayout">
        <motion.div
          animate={
            disableAnimation ? DEVICE_ANIMATE_STILL : DEVICE_ANIMATE_VISIBLE
          }
          exit={DEVICE_EXIT}
          initial={DEVICE_INITIAL}
          key={resolvedSrc}
          style={DEVICE_LAYER_STYLE}
          transition={
            disableAnimation ? DEVICE_STILL_TRANSITION : DEVICE_TRANSITION
          }
        >
          {image}
        </motion.div>
      </AnimatePresence>
    );
  }
);
